import { trpc } from "../trpc";
import { useUserAccountRole } from "../permissions/useUserAccountRole";

interface useQueryPausedZapsInput {
  enabled?: boolean;
}

export function useQueryPausedZaps({
  enabled = true,
}: useQueryPausedZapsInput) {
  const { customuserId, isSuperAdmin, isAdmin } = useUserAccountRole();

  const zapsResponse = trpc.zap.pausedZaps.useQuery(
    {
      isAdmin: isAdmin || isSuperAdmin,
      customuserId,
    },
    // /api/v4/zaps returns every Zap the caller can access (all of a large
    // account for admins), which is slow; batched, it holds up the others.
    { enabled, trpc: { context: { skipBatching: true } } },
  );

  return {
    isFetching: zapsResponse.isFetching,
    isLoading: zapsResponse.isLoading,
    response: zapsResponse.data,
  };
}
